(function () {
  function initPicker(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    document.body.classList.add('rp-sassy-picker-page');

    var variantsNode = root.querySelector('[data-picker-variants]');
    var variants = JSON.parse(variantsNode.textContent);
    var variantsById = {};
    variants.forEach(function (variant) {
      variantsById[String(variant.id)] = variant;
    });

    var bundleButtons = Array.from(root.querySelectorAll('[data-bundle-quantity]'));
    var pageSlots = root.querySelector('[data-picker-slots]');
    var dialogSlots = root.querySelector('[data-dialog-slots]');
    var colorsTitle = root.querySelector('[data-colors-title]');
    var primary = root.querySelector('[data-picker-primary]');
    var primaryLabel = root.querySelector('[data-primary-label]');
    var unitPrice = root.querySelector('[data-unit-price]');
    var bundlePrice = root.querySelector('[data-bundle-price]');
    var bundleCompare = root.querySelector('[data-bundle-compare]');
    var bundleMessage = root.querySelector('[data-bundle-summary]');
    var dialog = root.querySelector('[data-picker-dialog]');
    var dialogCount = root.querySelector('[data-dialog-count]');
    var status = root.querySelector('[data-picker-status]');
    var colorsRail = root.querySelector('[data-picker-colors]');
    var progressThumb = root.querySelector('[data-picker-progress-thumb]');
    var maxSlots = Number(root.dataset.maxSlots) || 5;
    var selected = [];
    var bundleQuantity = 3;
    var activeSlot = 0;
    var replaceMode = false;
    var busy = false;

    function currencyRate() {
      if (window.Shopify && window.Shopify.currency && Number(window.Shopify.currency.rate)) {
        return Number(window.Shopify.currency.rate);
      }
      var baseUnitPrice = Number(root.dataset.baseUnitPrice) || 1695;
      return variants.length ? variants[0].price / baseUnitPrice : 1;
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, root.dataset.moneyFormat);
      }
      if (root.dataset.moneyFormat && root.dataset.moneyFormat.indexOf('amount_with_comma_separator') !== -1) {
        var commaAmount = (cents / 100).toFixed(2).replace('.', ',');
        return root.dataset.moneyFormat.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, commaAmount);
      }
      var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    }

    function projectedRegularTotal() {
      var fallback = variants.length ? variants[0].price : 0;
      var total = 0;
      for (var index = 0; index < bundleQuantity; index += 1) {
        total += selected[index] ? selected[index].price : fallback;
      }
      return total;
    }

    function projectedTotal() {
      if (bundleQuantity === 6) {
        return Math.round((Number(root.dataset.baseSixPrice) || 6495) * currencyRate());
      }
      return projectedRegularTotal();
    }

    function countSelected() {
      return selected.filter(Boolean).length;
    }

    function firstEmptySlot() {
      for (var index = 0; index < bundleQuantity; index += 1) {
        if (!selected[index]) return index;
      }
      return 0;
    }

    function makeSlot(variant, index, compact, locked) {
      var slot = document.createElement('button');
      slot.type = 'button';
      slot.className = 'rp-sassy-picker__slot';
      if (locked) slot.classList.add('is-locked');
      if (index === activeSlot && dialog.open) slot.classList.add('is-active');
      slot.dataset.slotIndex = String(index);
      slot.setAttribute('aria-label', variant ? variant.title : 'Bracelet ' + (index + 1));
      slot.disabled = locked;

      if (locked) {
        var lock = document.createElement('span');
        lock.className = 'rp-sassy-picker__slot-lock';
        lock.innerHTML = '<svg viewBox="0 0 20 24" aria-hidden="true"><path d="M5 9V6a5 5 0 0 1 10 0v3h1.5A2.5 2.5 0 0 1 19 11.5v10a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 1 21.5v-10A2.5 2.5 0 0 1 3.5 9H5Zm3 0h4V6a2 2 0 0 0-4 0v3Z"/></svg>';
        slot.appendChild(lock);
      } else if (variant) {
        var image = document.createElement('img');
        image.src = variant.image;
        image.alt = variant.title;
        image.loading = compact ? 'eager' : 'lazy';
        slot.appendChild(image);

        var remove = document.createElement('span');
        remove.className = 'rp-sassy-picker__slot-remove';
        remove.dataset.removeSlot = String(index);
        remove.textContent = '×';
        remove.setAttribute('aria-label', 'Remove ' + variant.title);
        slot.appendChild(remove);
      } else {
        var label = document.createElement('span');
        label.className = 'rp-sassy-picker__slot-plus';
        label.textContent = '+';
        slot.appendChild(label);
      }
      return slot;
    }

    function renderSlots(host, compact) {
      host.innerHTML = '';
      for (var index = 0; index < maxSlots; index += 1) {
        var locked = index >= bundleQuantity;
        var slot = makeSlot(selected[index], index, compact, locked);
        if (compact) {
          host.appendChild(slot);
        } else {
          var item = document.createElement('div');
          item.className = 'rp-sassy-picker__slot-item';
          item.appendChild(slot);
          var caption = document.createElement('span');
          caption.textContent = 'Bracelet ' + (index + 1);
          item.appendChild(caption);
          host.appendChild(item);
        }
      }
    }

    function renderColorCards() {
      root.querySelectorAll('[data-color-card]').forEach(function (card) {
        var id = card.dataset.variantId;
        var selectedCount = selected.filter(function (variant) {
          return variant && String(variant.id) === id;
        }).length;
        card.classList.toggle('is-selected', selectedCount > 0);
        var addButton = card.querySelector('[data-add-variant]');
        var quantity = card.querySelector('[data-variant-quantity]');
        var count = card.querySelector('[data-variant-count]');
        var increase = card.querySelector('[data-increase-variant]');
        if (!addButton || !quantity || !count || card.classList.contains('is-unavailable')) return;

        addButton.hidden = selectedCount > 0;
        quantity.hidden = selectedCount === 0;
        count.textContent = String(selectedCount);
        addButton.disabled = countSelected() >= bundleQuantity;
        increase.disabled = countSelected() >= bundleQuantity;
      });
    }

    function updateProgress() {
      if (!colorsRail || !progressThumb) return;
      var maxScroll = Math.max(0, colorsRail.scrollWidth - colorsRail.clientWidth);
      var ratio = maxScroll ? colorsRail.scrollLeft / maxScroll : 0;
      progressThumb.style.left = Math.max(0, Math.min(1, ratio)) * 80 + '%';
    }

    function render() {
      var selectedCount = countSelected();
      var total = projectedTotal();
      var regularTotal = projectedRegularTotal();
      var selectedBundleButton = bundleButtons.find(function (button) {
        return Number(button.dataset.bundleQuantity) === bundleQuantity;
      });

      colorsTitle.textContent = bundleQuantity === 1 ? 'Choose your bracelet' : 'Choose your ' + bundleQuantity + ' bracelets';
      unitPrice.textContent = formatMoney(Math.round(total / bundleQuantity));
      bundlePrice.textContent = formatMoney(total);
      bundleCompare.hidden = total >= regularTotal;
      bundleCompare.textContent = total < regularTotal ? formatMoney(regularTotal) : '';
      if (bundleQuantity === 6) {
        bundleMessage.textContent = 'Helps us provide 60 meals to abandoned dogs · Free Shipping';
      } else if (bundleQuantity === 3) {
        bundleMessage.textContent = 'Helps us provide 30 meals to abandoned dogs · Free Shipping';
      } else if (selectedBundleButton) {
        bundleMessage.textContent = selectedBundleButton.dataset.bundleCopy;
      }
      dialogCount.textContent = selectedCount + '/' + bundleQuantity;
      primaryLabel.textContent = root.dataset.cartLabel;

      renderSlots(pageSlots, false);
      renderSlots(dialogSlots, true);
      renderColorCards();
      window.requestAnimationFrame(updateProgress);
    }

    var bundleMessageObserver = new MutationObserver(function () {
      var expected = bundleQuantity === 6
        ? 'Helps us provide 60 meals to abandoned dogs · Free Shipping'
        : bundleQuantity === 3
          ? 'Helps us provide 30 meals to abandoned dogs · Free Shipping'
          : 'Helps us provide 10 meals to abandoned dogs';
      if (bundleMessage.textContent !== expected) bundleMessage.textContent = expected;
    });
    bundleMessageObserver.observe(bundleMessage, { childList: true, characterData: true, subtree: true });

    function openDialog(slotIndex) {
      activeSlot = typeof slotIndex === 'number' ? slotIndex : firstEmptySlot();
      replaceMode = Boolean(selected[activeSlot]);
      status.hidden = true;
      document.body.classList.add('rp-sassy-picker-open');
      if (!dialog.open) dialog.showModal();
      render();
    }

    function closeDialog() {
      if (dialog.open) dialog.close();
      document.body.classList.remove('rp-sassy-picker-open');
      replaceMode = false;
    }

    function selectVariant(id) {
      var variant = variantsById[String(id)];
      if (!variant || !variant.available) return;

      if (replaceMode && selected[activeSlot]) {
        selected[activeSlot] = variant;
      } else {
        selected[firstEmptySlot()] = variant;
      }
      replaceMode = false;
      activeSlot = firstEmptySlot();
      render();
      if (countSelected() === bundleQuantity) {
        window.setTimeout(closeDialog, 180);
      }
    }

    function decreaseVariant(id) {
      for (var index = bundleQuantity - 1; index >= 0; index -= 1) {
        if (selected[index] && String(selected[index].id) === String(id)) {
          selected[index] = null;
          activeSlot = index;
          replaceMode = false;
          render();
          return;
        }
      }
    }

    function removeSlot(index) {
      selected[index] = null;
      activeSlot = index;
      render();
    }

    function getCartDrawer() {
      return document.querySelector('cart-drawer');
    }

    function setBusy(isBusy) {
      busy = isBusy;
      primary.disabled = isBusy;
      if (isBusy) {
        primaryLabel.textContent = root.dataset.addingLabel;
      } else {
        render();
      }
    }

    function addToCart() {
      if (countSelected() < bundleQuantity) {
        openDialog(firstEmptySlot());
        return;
      }
      if (busy) return;

      var quantities = {};
      selected.forEach(function (variant) {
        var id = String(variant.id);
        quantities[id] = (quantities[id] || 0) + 1;
      });
      var items = Object.keys(quantities).map(function (id) {
        var selectedBundleButton = bundleButtons.find(function (button) {
          return Number(button.dataset.bundleQuantity) === bundleQuantity;
        });
        var kachingProperty = JSON.stringify({
          deal: root.dataset.kachingDeal,
          pp: Number(root.dataset.productId),
          main: true,
          v: root.dataset.kachingVersion,
          bid: selectedBundleButton.dataset.kachingBar
        });
        return {
          id: Number(id),
          quantity: quantities[id],
          properties: { __kaching_bundles: kachingProperty }
        };
      });

      var drawer = getCartDrawer();
      var body = { items: items };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map(function (section) {
          return section.section || section.id;
        });
        body.sections_url = window.location.pathname;
      }

      setBusy(true);
      var rootRoute = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      fetch(rootRoute + 'cart/add.js?kaching_bundles=true', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Kaching-Cart-Ignore': '1'
        },
        body: JSON.stringify(body)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart request failed');
          return response.json();
        })
        .then(function (response) {
          closeDialog();
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.classList.remove('is-empty');
            drawer.renderContents(response);
            if (typeof drawer.open === 'function') drawer.open();
          } else {
            window.location.assign(rootRoute + 'cart');
          }
        })
        .catch(function () {
          closeDialog();
          status.textContent = root.dataset.errorLabel;
          status.hidden = false;
        })
        .finally(function () {
          setBusy(false);
        });
    }

    bundleButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        bundleQuantity = Number(button.dataset.bundleQuantity);
        selected = selected.slice(0, bundleQuantity);
        activeSlot = firstEmptySlot();
        replaceMode = false;
        bundleButtons.forEach(function (item) {
          var isSelected = item === button;
          item.classList.toggle('is-selected', isSelected);
          item.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        });
        render();
      });
    });

    root.addEventListener('click', function (event) {
      var addButton = event.target.closest('[data-add-variant], [data-increase-variant]');
      if (addButton) {
        selectVariant(addButton.closest('[data-color-card]').dataset.variantId);
        return;
      }

      var decreaseButton = event.target.closest('[data-decrease-variant]');
      if (decreaseButton) {
        decreaseVariant(decreaseButton.closest('[data-color-card]').dataset.variantId);
        return;
      }

      var removeButton = event.target.closest('[data-remove-slot]');
      if (removeButton) {
        event.stopPropagation();
        removeSlot(Number(removeButton.dataset.removeSlot));
        return;
      }

      var slot = event.target.closest('[data-slot-index]');
      if (slot) {
        openDialog(Number(slot.dataset.slotIndex));
      }
    });

    primary.addEventListener('click', function () {
      if (countSelected() < bundleQuantity) openDialog(firstEmptySlot());
      else addToCart();
    });
    root.querySelector('[data-picker-close]').addEventListener('click', closeDialog);
    root.querySelector('[data-picker-close-bottom]').addEventListener('click', closeDialog);
    dialog.addEventListener('cancel', function () {
      document.body.classList.remove('rp-sassy-picker-open');
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeDialog();
    });
    colorsRail.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
    render();
  }

  function initAll() {
    document.querySelectorAll('[data-rp-sassy-picker]').forEach(initPicker);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
